// IMPORTS
// Modules
import { useEffect, useState } from 'react';
// OHS
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSTiles from '../../../../onehivesystems/js/OHSTiles';
// Assets
import './Dashboard.scss';
import OverallUsage from './Modules/OverallUsage';
import UsageByLocation from './Modules/UsageByLocation';
import UsageByPortType from './Modules/UsageByPortType';
import Top10MostUsedDevices from './Modules/Top10MostUsedDevices';
import Expirations from './Modules/Expirations';


// COMPONENT
export default function Dashboard (props) {
   // States and Variables
   const [overallUsage, setOverallUsage] = useState({
      current: 0,
      max: 0
   });
   const [usageByLocation, setUsageByLocation] = useState([]);
   const [usageByPortType, setUsageByPortType] = useState([]);
   const [top10MostUsedDevices, setTop10MostUsedDevices] = useState([]);
   const [expirations, setExpirations] = useState([]);

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Dashboard"); // set page title
      getOverallUsage();
      getUsageByLocation();
      getUsageByPortType();
      getTop10MostUsedDevices();
      getExpirations();
   }, []);

   // Functions
   const getOverallUsage = function () {
      OHSCRUD({
         url: '/v1/oneport/dashboard/overallusage',
         method: 'GET',
         success: function (data) {
            setOverallUsage(data);
         }
      });
   }
   const getUsageByLocation = function () {
      OHSCRUD({
         url: '/v1/oneport/dashboard/usagebylocation',
         method: 'GET',
         success: function (data) {
            setUsageByLocation(data);
         }
      });
   }
   const getUsageByPortType = function () {
      OHSCRUD({
         url: '/v1/oneport/dashboard/usagebyporttype',
         method: 'GET',
         success: function (data) {
            setUsageByPortType(data);
         }
      });
   }
   const getTop10MostUsedDevices = function () {
      OHSCRUD({
         url: '/v1/oneport/dashboard/top10mostuseddevices',
         method: 'GET',
         success: function (data) {
            setTop10MostUsedDevices(data);
         }
      });
   }
   const getExpirations = function () {
      OHSCRUD({
         url: '/v1/oneport/dashboard/expirations',
         method: 'GET',
         success: function (data) {
            setExpirations(data);
         }
      });
   }

   // Component
   return (
      <div className="oneport-dashboard">
         <OHSAppHeader onehive={props.onehive} title="Dashboard" help="https://www.onehivesystems.com/documentation/oneport/dashboard" />
         <OHSAppBody onehive={props.onehive}>
            <OHSTiles onehive={props.onehive} content={[
               {
                  title: "Overall Usage",
                  content: <OverallUsage onehive={props.onehive} parent={{
                     overallUsage: overallUsage
                  }} />
               },
               {
                  title: "Usage by Location",
                  content: <UsageByLocation onehive={props.onehive} parent={{
                     usageByLocation: usageByLocation
                  }} />
               },
               {
                  title: "Usage by Port Type",
                  content: <UsageByPortType onehive={props.onehive} parent={{
                     usageByPortType: usageByPortType
                  }} />
               },
               {
                  title: "Top 10 Most Used Devices",
                  content: <Top10MostUsedDevices onehive={props.onehive} parent={{
                     top10MostUsedDevices: top10MostUsedDevices
                  }} />
               },
               {
                  title: "Expirations",
                  content: <Expirations onehive={props.onehive} parent={{
                     expirations: expirations
                  }} />
               }
            ]} />
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}